// Connected · EntitySelectProvider
//
// Provides the real `EntitySelect` renderer to the `EntitySelectContext`.
// Mount once near the Refine app root so every `tables/` cell that renders
// an entity-select dropdown gets the live Refine-backed component.
//
// Without this provider the context falls back to a no-op null renderer —
// useful in tests (render a stub via EntitySelectContext directly).

import React, { type ReactNode } from "react";
import {
  EntitySelectContextProvider,
  type EntitySelectRendererProps,
} from "@ds/display/EntitySelectContext";
import { EntitySelect, type EntityKind } from "@ds/connected/EntitySelect";

function renderEntitySelect({ kind, ...rest }: EntitySelectRendererProps): ReactNode {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <EntitySelect kind={kind as EntityKind} {...(rest as any)} />
  );
}

export interface EntitySelectProviderProps {
  children: ReactNode;
}

/**
 * Mount once at the app root (inside Refine providers).
 *
 * ```tsx
 * <EntitySelectProvider>
 *   <App />
 * </EntitySelectProvider>
 * ```
 */
export function EntitySelectProvider({ children }: EntitySelectProviderProps): React.ReactElement {
  return (
    <EntitySelectContextProvider renderer={renderEntitySelect}>
      {children}
    </EntitySelectContextProvider>
  );
}
